/**
 * 새 탭에서 주소를 엽니다.
 * @param url 주소
 */
export function openInNewTab(url: string) {
  const win = window.open(url, "_blank");
  if (win) win.focus();
}
